export enum PieceType {
    PAWN = "pawn",
    BISHOP = "bishop",
    KNIGHT = "knight",
    ROOK = "rook",
    QUEEN ="queen",
    KING = "king",
  }
  export enum TeamType {
    OPPONENT ="b",
    OUR ="w",
  }